module.exports = __webpack_public_path__ + "img/921_part1_cover_pc.ec6f0b4c.jpg";